import {ClusterWorkflowTemplateContainer} from './components/cluster-workflow-template-container';

export default {
    component: ClusterWorkflowTemplateContainer
};
